import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BackstageEndpoint } from './backstage-endpoint';

@Injectable({
  providedIn: 'root',
})
export class BackstageRoutingResolver
  
{
  constructor(private http: HttpClient, private router: Router) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return this.http
      .get(route.data.dataUrl, {
        params: {
          btsPostsPerPage: 200,
        },
      })
      .pipe(
        catchError((err) => {
          console.error(err);
          this.router.navigate(['/']);
          return EMPTY;
        })
      );
  }
}
